import { Grid } from '@mui/material';

import { FormAutocompleteField, FormDateField, FormRichTextField } from '../../../../../common';
import { disabledFutureDate } from '../../../../../../helpers';
import AdditionalFilesViewedField from './AdditionalFilesViewedField';
import { DIAGNOSTIC_REPORT_REVIEWED_OPTIONS } from '../constants';
import { DATE_DISPLAY_FORMAT } from '../../../../../../constants';

import type { AssessmentInfoFieldsProps } from './types';

export default function AssessmentInfoFields({
  formik,
  disabled,
  readOnly,
  saveField,
  templates,
}: AssessmentInfoFieldsProps) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <FormDateField
          disabled={disabled}
          disabledDate={disabledFutureDate}
          formik={formik}
          format={DATE_DISPLAY_FORMAT}
          label="Initial assessment date"
          name="initial_assessment_date"
          onChange={saveField}
          placeholder={DATE_DISPLAY_FORMAT}
          readOnly={readOnly}
          required
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <FormAutocompleteField
          disabled={disabled}
          formik={formik}
          label="Was diagnostic report reviewed"
          name="diagnostic_report_reviewed"
          onChange={saveField}
          options={DIAGNOSTIC_REPORT_REVIEWED_OPTIONS}
          placeholder="Select option"
          readOnly={readOnly}
          required
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <FormDateField
          disabled={disabled}
          disabledDate={disabledFutureDate}
          formik={formik}
          format={DATE_DISPLAY_FORMAT}
          label="Re-assessment date"
          name="reassessment_date"
          onChange={saveField}
          placeholder={DATE_DISPLAY_FORMAT}
          readOnly={readOnly}
          required
        />
      </Grid>
      <Grid item xs={12}>
        <FormRichTextField
          disabled={disabled}
          formik={formik}
          label="Parent interview summary"
          name="parent_interview_summary"
          onBlur={saveField}
          placeholder="Use this section to summarize parent interviews (occurs during initial assessment with BCBA). Recommendation to barriers parents observe, in home, school and/or community. Include the top three goals that the family would like to work on. This section needs to be 6 sentences or more."
          readOnly={readOnly}
          required
          showTemplateButton
          templateValue={templates?.page.parent_interview_summary}
        />
      </Grid>
      <Grid item xs={12}>
        <AdditionalFilesViewedField
          disabled={disabled}
          formik={formik}
          readOnly={readOnly}
          saveField={saveField}
        />
      </Grid>
    </Grid>
  );
}
